<template>
  <div class="invoice-wrap">
    <div class="title-wrap">
      <h2 class="title">
        <span>发票信息：</span>
        <el-button
          type="text"
          class="invoice-btn"
          @click="addInvoice"
          icon="el-icon-plus"
        >
          新增发票
        </el-button>
      </h2>
    </div>
    <div class="type-list">
      <div
        :class="[
          'type-item',
          `type-item-${item.value}`,
          {
            active: invoiceActive === item.value
          }
        ]"
        @click="changeType(item.value)"
        v-for="(item, index) in types"
        :key="index"
      >
        <i></i>
        {{ item.label }}
      </div>
    </div>
    <div class="list" v-if="invoiceActive !== '30'">
      <div
        class="item"
        :class="{ active: item.invoiceId === invoiceId }"
        @click="checkedInvoice(item)"
        v-for="(item, index) in list.filter(
          (v) => v.invoiceType === invoiceActive
        )"
        :key="index"
      >
        <div class="companyName ellipsis" :title="item.companyName">
          <span style="padding-right: 20px">{{ item.companyName }}</span>
          <span v-if="item.defaultFlag === '1'" class="default">默认</span>
        </div>
        <div class="taxpayerIdentity">
          <span style="flex: 1">{{ item.taxpayerIdentity || '-' }}</span>
        </div>
        <div class="btns">
          <el-button @click.stop="editInvoice(item)" type="text" class="plc-btn"
            >编辑</el-button
          >
          <el-button
            style="margin-left: 16px"
            @click.stop="delInvoice(item)"
            type="text"
            class="plc-btn"
            >删除</el-button
          >
        </div>
      </div>
      <div class="no-data" v-if="list.filter(
          (v) => v.invoiceType === invoiceActive
        ).length === 0">没有任何发票</div>
    </div>
    <el-dialog
      :title="row.invoiceId ? '编辑发票抬头' : '新增发票抬头'"
      :visible.sync="dialogVisible"
      width="800px"
    >
      <AddInvoice
        :row="row"
        @refreshDataList="refreshDataList"
        v-if="dialogVisible"
      ></AddInvoice>
    </el-dialog>
  </div>
</template>

<script>
import AddInvoice from './addInvoice.vue'
export default {
  props: {
    invoiceActive: {
      type: String,
      default: '20'
    },
    companyId: {
      type: String,
      default: ''
    }
  },
  components: {
    AddInvoice
  },
  data () {
    return {
      types: [
        {
          label: '增值税专用发票',
          value: '20'
        },
        {
          label: '增值税普通发票',
          value: '10'
        },
        {
          label: '暂时不开发票',
          value: '30'
        }
      ],
      list: [],
      row: {},
      dialogVisible: false,
      invoiceId: ''
    }
  },
  created () {
    this.getList()
  },
  methods: {
    refreshDataList () {
      this.dialogVisible = false
      this.getList()
    },
    changeType (value) {
      this.$emit('change', value)
    },
    checkedInvoice (row) {
      this.invoiceId = row.invoiceId
      this.$emit('setInvoiceId', this.invoiceId)
    },
    // 获取发票列表
    getList () {
      this.$http
        .get(
          `/front/consumer/order/payinvoice/getUserAllInvoiceList?companyId=${this.companyId}`
        )
        .then(({ data: res }) => {
          this.list = res.data || []
        })
        .catch()
    },
    addInvoice () {
      this.row = {}
      this.dialogVisible = true
    },
    editInvoice (v) {
      this.row = v
      this.dialogVisible = true
    },
    delInvoice (row) {
      this.$confirm(`确定要删除该发票吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDelInvoice(row)
      })
    },
    doDelInvoice (row) {
      this.$http
        .post(`/front/consumer/order/payinvoice/delete`, [row.invoiceId])
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.getList()
            this.$message.success('删除成功')
          }
        })
    },
    getResult () {
      if (this.invoiceActive !== '30' && !this.invoiceId) {
        this.$message.warning('请选择发票')
        return false
      }
      return this.list.find((v) => v.invoiceId === this.invoiceId)
    }
  }
}
</script>

<style lang="scss" scoped>
.invoice-wrap {
  display: flex;
  flex-direction: column;
  background: #fff;
  padding: 16px 28px;
  border-radius: 12px;
  height: 100%;
}

.title {
  display: flex;
  align-items: center;
  font-size: 16px;
  margin: 0;
  color: #000000;
  .el-button {
    font-size: 12px;
    color: #2a54d1;
  }
}

.type-list {
  display: flex;
  padding: 16px 0;
  .type-item {
    display: flex;
    align-items: center;
    width: 160px;
    height: 40px;
    border-radius: 8px;
    background: #ffffff;
    box-sizing: border-box;
    border: 1px solid rgba(42, 84, 209, 0.2);
    padding: 6px;
    margin-left: 28px;
    cursor: pointer;

    &.type-item-20 {
      margin-left: 0;
      i {
        background: #f59b24;
        color: #fff;
        &::after {
          content: '专';
        }
      }
      &:hover,
      &.active {
        background: #f59b24;
        border-color: #f59b24;
        color: #fff;
        i {
          background: #fff;
          color: #f59b24;
        }
      }
    }
    &.type-item-10 {
      i {
        background: #2a54d1;
        color: #fff;
        &::after {
          content: '普';
        }
      }
      &:hover,
      &.active {
        background: #2a54d1;
        border-color: #2a54d1;
        color: #fff;
        i {
          background: #fff;
          color: #2a54d1;
        }
      }
    }
    &.type-item-30 {
      i {
        background: #d0d0d0;
        color: #fff;
        &::after {
          content: '无';
        }
      }
      &:hover,
      &.active {
        background: #d0d0d0;
        border-color: #d0d0d0;
        color: #fff;
        i {
          background: #fff;
          color: #d0d0d0;
        }
      }
    }
    i {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 28px;
      height: 28px;
      font-size: 16px;
      font-weight: bold;
      border-radius: 4px;
      font-style: normal;
      margin-right: 6px;
    }
  }
}

.list {
  max-height: 300px;
  overflow: auto;
  .item {
    display: flex;
    align-items: center;
    border-radius: 8px;
    background: #f5f8ff;
    border: 1px solid #f5f8ff;
    margin-top: 8px;
    padding: 9px 16px;
    font-size: 14px;
    color: #3d3d3d;
    cursor: pointer;
    &.active {
      border-color: #2a54d1;
    }
    &:first-child {
      margin-top: 0;
    }
  }
  .companyName {
    flex: 1;
  }
  .taxpayerIdentity {
    display: flex;
    align-items: center;
    flex: 1;
    text-align: center;
    &:before,
    &:after {
      display: block;
      content: '';
      width: 0.5px;
      height: 21px;
      background: rgba(61, 61, 61, 0.4);
    }
  }
  .btns {
    width: 100px;
    padding: 0 0 0 20px;
    > button {
      height: 19px;
      padding: 0;
    }
  }
}

.no-data {
  text-align: center;
  padding: 20px 0;
  font-size: 14px;
  color: #999;
}

.default {
  display: inline-block;
  width: 32px;
  height: 17px;
  line-height: 17px;
  border-radius: 4px;
  background: #2a54d1;
  font-size: 12px;
  color: #ffffff;
  text-align: center;
  cursor: default;
}

</style>
